import orderSummaryStyles from '../OrderSummary.scss';

import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCart } from 'src/components/Cart/UseCart';
import { useCheckout } from 'src/components/Checkout/CheckoutProvider';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { Installments } from '../types';
import { useTax } from '../useTax/useTax';

export const DueToday: React.FC = () => {
  const { t } = useTranslation();
  const { checkout } = useCart();
  const { selectedPurchaseType } = useCheckout();
  const { installmentPlans } = checkout || {};
  const { isTaxSet, taxPrice } = useTax();

  const selectedPlanCost = selectedPurchaseType === Installments.P ? checkout?.subtotal : installmentPlans?.find(plan => plan.id === selectedPurchaseType.toString())?.cost || 0;

  const price = +(selectedPlanCost + taxPrice).toFixed(2);

  const priceText = isTaxSet
    ? t('order-summary.price', { price })
    : t('order-summary.due-today-price-with-tax-placeholder', { price });

  return (
    <section className={cx(orderSummaryStyles.section, orderSummaryStyles.sectionDueToday)}>
      <h4 className={cx(orderSummaryStyles.subheading, orderSummaryStyles.subheadingSpaced)}>
        <TextV2
          variant="body-medium"
          tagName="span"
          value={t('order-summary.due-today-title')}
          data-test="due-today-title"
        />

        <TextV2
          variant="body-medium"
          tagName="span"
          value={priceText}
          data-test="due-today-price"
        />
      </h4>
    </section>
  );
};

DueToday.displayName = 'DueToday';
